import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import './media/gotoErrorWidget.css';
import * as nls from '../../../nls.js';
import * as dom from '../../../base/browser/dom.js';
import { dispose as _dispose, DisposableStore } from '../../../base/common/lifecycle.js';
import { MarkerSeverity } from '../../../platform/markers/common/markers.js';
import { Range } from '../../common/core/range.js';
import { registerColor, oneOf, textLinkForeground, editorErrorForeground, editorErrorBorder, editorWarningForeground, editorWarningBorder, editorInfoForeground, editorInfoBorder } from '../../../platform/theme/common/colorRegistry.js';
import { IThemeService, registerThemingParticipant } from '../../../platform/theme/common/themeService.js';
import { Color } from '../../../base/common/color.js';
import { ScrollableElement } from '../../../base/browser/ui/scrollbar/scrollableElement.js';
import { getBaseLabel, getPathLabel } from '../../../base/common/labels.js';
import { isNonEmptyArray } from '../../../base/common/arrays.js';
import { Emitter } from '../../../base/common/event.js';
import { PeekViewWidget, peekViewTitleForeground, peekViewTitleInfoForeground } from '../peekView/peekView.js';
import { basename } from '../../../base/common/resources.js';
import { SeverityIcon } from '../../../platform/severityIcon/common/severityIcon.js';
import { IOpenerService } from '../../../platform/opener/common/opener.js';
import { MenuId, IMenuService } from '../../../platform/actions/common/actions.js';
import { IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { createAndFillInActionBarActions } from '../../../platform/actions/browser/menuEntryActionViewItem.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';

var MessageWidget = /*#__PURE__*/function () {
  function MessageWidget(parent, editor, onRelatedInformation, _openerService) {
    var _this = this;

    _classCallCheck(this, MessageWidget);

    this._openerService = _openerService;
    this._lines = 0;
    this._longestLineLength = 0;
    this._relatedDiagnostics = new WeakMap();
    this._disposables = new DisposableStore();
    this._editor = editor;
    var domNode = document.createElement('div');
    domNode.className = 'descriptioncontainer';
    this._messageBlock = document.createElement('div');
    dom.addClass(this._messageBlock, 'message');

    this._messageBlock.setAttribute('aria-live', 'assertive');

    this._messageBlock.setAttribute('role', 'alert');

    domNode.appendChild(this._messageBlock);
    this._relatedBlock = document.createElement('div');
    domNode.appendChild(this._relatedBlock);

    this._disposables.add(dom.addStandardDisposableListener(this._relatedBlock, 'click', function (event) {
      event.preventDefault();

      var related = _this._relatedDiagnostics.get(event.target);

      if (related) {
        onRelatedInformation(related);
      }
    }));

    this._scrollable = new ScrollableElement(domNode, {
      horizontal: 1
      /* Auto */
      ,
      vertical: 1
      /* Auto */
      ,
      useShadows: false,
      horizontalScrollbarSize: 3,
      verticalScrollbarSize: 3
    });
    parent.appendChild(this._scrollable.getDomNode());

    this._disposables.add(this._scrollable.onScroll(function (e) {
      domNode.style.left = "-".concat(e.scrollLeft, "px");
      domNode.style.top = "-".concat(e.scrollTop, "px");
    }));

    this._disposables.add(this._scrollable);
  }

  _createClass(MessageWidget, [{
    key: "dispose",
    value: function dispose() {
      _dispose(this._disposables);
    }
  }, {
    key: "update",
    value: function update(marker) {
      var _this2 = this;

      var source = marker.source,
          message = marker.message,
          relatedInformation = marker.relatedInformation,
          code = marker.code;
      var sourceAndCodeLength = ((source === null || source === void 0 ? void 0 : source.length) || 0) + '()'.length;

      if (code) {
        if (typeof code === 'string') {
          sourceAndCodeLength += code.length;
        } else {
          sourceAndCodeLength += code.value.length;
        }
      }

      var lines = message.split(/\r\n|\r|\n/g);
      this._lines = lines.length;
      this._longestLineLength = 0;

      var _iterator = _createForOfIteratorHelper(lines),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          this._longestLineLength = Math.max(line.length + sourceAndCodeLength, this._longestLineLength);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      dom.clearNode(this._messageBlock);

      this._messageBlock.setAttribute('aria-label', this.getAriaLabel(marker));

      this._editor.applyFontInfo(this._messageBlock);

      var lastLineElement = this._messageBlock;

      var _iterator2 = _createForOfIteratorHelper(lines),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _line = _step2.value;
          lastLineElement = document.createElement('div');
          lastLineElement.innerText = _line;

          if (_line === '') {
            lastLineElement.style.height = this._messageBlock.style.lineHeight;
          }

          this._messageBlock.appendChild(lastLineElement);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (source || code) {
        var detailsElement = document.createElement('span');
        dom.addClass(detailsElement, 'details');
        lastLineElement.appendChild(detailsElement);

        if (source) {
          var sourceElement = document.createElement('span');
          sourceElement.innerText = source;
          dom.addClass(sourceElement, 'source');
          detailsElement.appendChild(sourceElement);
        }

        if (code) {
          if (typeof code === 'string') {
            var codeElement = document.createElement('span');
            codeElement.innerText = "(".concat(code, ")");
            dom.addClass(codeElement, 'code');
            detailsElement.appendChild(codeElement);
          } else {
            this._codeLink = dom.$('a.code-link');

            this._codeLink.setAttribute('href', "".concat(code.target.toString()));

            this._codeLink.onclick = function (e) {
              _this2._openerService.open(code.target);

              e.preventDefault();
              e.stopPropagation();
            };

            var _codeElement = dom.append(this._codeLink, dom.$('span'));

            _codeElement.innerText = code.value;
            detailsElement.appendChild(this._codeLink);
          }
        }
      }

      dom.clearNode(this._relatedBlock);

      this._editor.applyFontInfo(this._relatedBlock);

      if (isNonEmptyArray(relatedInformation)) {
        var relatedInformationNode = this._relatedBlock.appendChild(document.createElement('div'));

        relatedInformationNode.style.paddingTop = "".concat(Math.floor(this._editor.getOption(51
        /* lineHeight */
        ) * 0.66), "px");
        this._lines += 1;

        var _iterator3 = _createForOfIteratorHelper(relatedInformation),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var related = _step3.value;
            var container = document.createElement('div');
            var relatedResource = document.createElement('a');
            dom.addClass(relatedResource, 'filename');
            relatedResource.innerText = "".concat(getBaseLabel(related.resource), "(").concat(related.startLineNumber, ", ").concat(related.startColumn, "): ");
            relatedResource.title = getPathLabel(related.resource, undefined);

            this._relatedDiagnostics.set(relatedResource, related);

            var relatedMessage = document.createElement('span');
            relatedMessage.innerText = related.message;
            container.appendChild(relatedResource);
            container.appendChild(relatedMessage);
            this._lines += 1;
            relatedInformationNode.appendChild(container);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      var fontInfo = this._editor.getOption(36
      /* fontInfo */
      );

      var scrollWidth = Math.ceil(fontInfo.typicalFullwidthCharacterWidth * this._longestLineLength * 0.75);
      var scrollHeight = fontInfo.lineHeight * this._lines;

      this._scrollable.setScrollDimensions({
        scrollWidth: scrollWidth,
        scrollHeight: scrollHeight
      });
    }
  }, {
    key: "layout",
    value: function layout(height, width) {
      this._scrollable.getDomNode().style.height = "".concat(height, "px");
      this._scrollable.getDomNode().style.width = "".concat(width, "px");

      this._scrollable.setScrollDimensions({
        width: width,
        height: height
      });
    }
  }, {
    key: "getHeightInLines",
    value: function getHeightInLines() {
      return Math.min(17, this._lines);
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel(marker) {
      var severityLabel = '';

      switch (marker.severity) {
        case MarkerSeverity.Error:
          severityLabel = nls.localize('Error', "Error");
          break;

        case MarkerSeverity.Warning:
          severityLabel = nls.localize('Warning', "Warning");
          break;

        case MarkerSeverity.Info:
          severityLabel = nls.localize('Info', "Info");
          break;

        case MarkerSeverity.Hint:
          severityLabel = nls.localize('Hint', "Hint");
          break;
      }

      var ariaLabel = nls.localize('marker aria', "{0} at {1}. ", severityLabel, marker.startLineNumber + ':' + marker.startColumn);

      var model = this._editor.getModel();

      if (model && marker.startLineNumber <= model.getLineCount() && marker.startLineNumber >= 1) {
        var lineContent = model.getLineContent(marker.startLineNumber);
        ariaLabel = "".concat(lineContent, ", ").concat(ariaLabel);
      }

      return ariaLabel;
    }
  }]);

  return MessageWidget;
}();

var MarkerNavigationWidget = /*#__PURE__*/function (_PeekViewWidget) {
  _inherits(MarkerNavigationWidget, _PeekViewWidget);

  var _super = _createSuper(MarkerNavigationWidget);

  function MarkerNavigationWidget(editor, _themeService, _openerService, _menuService, instantiationService, _contextKeyService) {
    var _this3;

    _classCallCheck(this, MarkerNavigationWidget);

    _this3 = _super.call(this, editor, {
      showArrow: true,
      showFrame: true,
      isAccessible: true
    }, instantiationService);
    _this3._themeService = _themeService;
    _this3._openerService = _openerService;
    _this3._menuService = _menuService;
    _this3._contextKeyService = _contextKeyService;
    _this3._callOnDispose = new DisposableStore();
    _this3._onDidSelectRelatedInformation = new Emitter();
    _this3.onDidSelectRelatedInformation = _this3._onDidSelectRelatedInformation.event;
    _this3._severity = MarkerSeverity.Warning;
    _this3._backgroundColor = Color.white;

    _this3._applyTheme(_themeService.getColorTheme());

    _this3._callOnDispose.add(_themeService.onDidColorThemeChange(_this3._applyTheme.bind(_assertThisInitialized(_this3))));

    _this3.create();

    return _this3;
  }

  _createClass(MarkerNavigationWidget, [{
    key: "_applyTheme",
    value: function _applyTheme(theme) {
      this._backgroundColor = theme.getColor(editorMarkerNavigationBackground);
      var colorId = editorMarkerNavigationError;

      if (this._severity === MarkerSeverity.Warning) {
        colorId = editorMarkerNavigationWarning;
      } else if (this._severity === MarkerSeverity.Info) {
        colorId = editorMarkerNavigationInfo;
      }

      var frameColor = theme.getColor(colorId);
      this.style({
        arrowColor: frameColor,
        frameColor: frameColor,
        headerBackgroundColor: this._backgroundColor,
        primaryHeadingColor: theme.getColor(peekViewTitleForeground),
        secondaryHeadingColor: theme.getColor(peekViewTitleInfoForeground)
      }); // style() will trigger _applyStyles
    }
  }, {
    key: "_applyStyles",
    value: function _applyStyles() {
      if (this._parentContainer) {
        this._parentContainer.style.backgroundColor = this._backgroundColor ? this._backgroundColor.toString() : '';
      }

      _get(_getPrototypeOf(MarkerNavigationWidget.prototype), "_applyStyles", this).call(this);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._callOnDispose.dispose();

      _get(_getPrototypeOf(MarkerNavigationWidget.prototype), "dispose", this).call(this);
    }
  }, {
    key: "_fillHead",
    value: function _fillHead(container) {
      var _this4 = this;

      _get(_getPrototypeOf(MarkerNavigationWidget.prototype), "_fillHead", this).call(this, container);

      this._disposables.add(this._actionbarWidget.actionRunner.onDidBeforeRun(function (e) {
        return _this4.editor.focus();
      }));

      var actions = [];

      var menu = this._menuService.createMenu(MarkerNavigationWidget.TitleMenu, this._contextKeyService);

      createAndFillInActionBarActions(menu, undefined, actions);

      this._actionbarWidget.push(actions, {
        label: false,
        icon: true,
        index: 0
      });

      menu.dispose();
    }
  }, {
    key: "_fillTitleIcon",
    value: function _fillTitleIcon(container) {
      this._icon = dom.append(container, dom.$(''));
    }
  }, {
    key: "_getActionBarOptions",
    value: function _getActionBarOptions() {
      return Object.assign(Object.assign({}, _get(_getPrototypeOf(MarkerNavigationWidget.prototype), "_getActionBarOptions", this).call(this)), {
        orientation: 0
        /* HORIZONTAL */

      });
    }
  }, {
    key: "_fillBody",
    value: function _fillBody(container) {
      var _this5 = this;

      this._parentContainer = container;
      dom.addClass(container, 'marker-widget');
      this._parentContainer.tabIndex = 0;

      this._parentContainer.setAttribute('role', 'tooltip');

      this._container = document.createElement('div');
      container.appendChild(this._container);
      this._message = new MessageWidget(this._container, this.editor, function (related) {
        return _this5._onDidSelectRelatedInformation.fire(related);
      }, this._openerService);

      this._disposables.add(this._message);
    }
  }, {
    key: "show",
    value: function show() {
      throw new Error('call showAtMarker');
    }
  }, {
    key: "showAtMarker",
    value: function showAtMarker(marker, markerIdx, markerCount) {
      // update:
      // * title
      // * message
      this._container.classList.remove('stale');

      this._message.update(marker); // update frame color (only applied on 'show')


      this._severity = marker.severity;

      this._applyTheme(this._themeService.getColorTheme()); // show


      var range = Range.lift(marker);
      var editorPosition = this.editor.getPosition();
      var position = editorPosition && range.containsPosition(editorPosition) ? editorPosition : range.getStartPosition();

      _get(_getPrototypeOf(MarkerNavigationWidget.prototype), "show", this).call(this, position, this.computeRequiredHeight());

      var model = this.editor.getModel();

      if (model) {
        var detail = markerCount > 1 ? nls.localize('problems', "{0} of {1} problems", markerIdx, markerCount) : nls.localize('change', "{0} of {1} problem", markerIdx, markerCount);
        this.setTitle(basename(model.uri), detail);
      }

      this._icon.className = "codicon ".concat(SeverityIcon.className(MarkerSeverity.toSeverity(this._severity)));
      this.editor.revealPositionNearTop(position, 0
      /* Smooth */
      );
      this.editor.focus();
    }
  }, {
    key: "updateMarker",
    value: function updateMarker(marker) {
      this._container.classList.remove('stale');

      this._message.update(marker);
    }
  }, {
    key: "showStale",
    value: function showStale() {
      this._container.classList.add('stale');

      this._relayout();
    }
  }, {
    key: "_doLayoutBody",
    value: function _doLayoutBody(heightInPixel, widthInPixel) {
      _get(_getPrototypeOf(MarkerNavigationWidget.prototype), "_doLayoutBody", this).call(this, heightInPixel, widthInPixel);

      this._heightInPixel = heightInPixel;

      this._message.layout(heightInPixel, widthInPixel);

      this._container.style.height = "".concat(heightInPixel, "px");
    }
  }, {
    key: "_onWidth",
    value: function _onWidth(widthInPixel) {
      this._message.layout(this._heightInPixel, widthInPixel);
    }
  }, {
    key: "_relayout",
    value: function _relayout() {
      _get(_getPrototypeOf(MarkerNavigationWidget.prototype), "_relayout", this).call(this, this.computeRequiredHeight());
    }
  }, {
    key: "computeRequiredHeight",
    value: function computeRequiredHeight() {
      return 3 + this._message.getHeightInLines();
    }
  }]);

  return MarkerNavigationWidget;
}(PeekViewWidget);

MarkerNavigationWidget.TitleMenu = new MenuId('gotoErrorTitleMenu');
MarkerNavigationWidget = __decorate([__param(1, IThemeService), __param(2, IOpenerService), __param(3, IMenuService), __param(4, IInstantiationService), __param(5, IContextKeyService)], MarkerNavigationWidget);
export { MarkerNavigationWidget }; // theming

var errorDefault = oneOf(editorErrorForeground, editorErrorBorder);
var warningDefault = oneOf(editorWarningForeground, editorWarningBorder);
var infoDefault = oneOf(editorInfoForeground, editorInfoBorder);
export var editorMarkerNavigationError = registerColor('editorMarkerNavigationError.background', {
  dark: errorDefault,
  light: errorDefault,
  hc: errorDefault
}, nls.localize('editorMarkerNavigationError', 'Editor marker navigation widget error color.'));
export var editorMarkerNavigationWarning = registerColor('editorMarkerNavigationWarning.background', {
  dark: warningDefault,
  light: warningDefault,
  hc: warningDefault
}, nls.localize('editorMarkerNavigationWarning', 'Editor marker navigation widget warning color.'));
export var editorMarkerNavigationInfo = registerColor('editorMarkerNavigationInfo.background', {
  dark: infoDefault,
  light: infoDefault,
  hc: infoDefault
}, nls.localize('editorMarkerNavigationInfo', 'Editor marker navigation widget info color.'));
export var editorMarkerNavigationBackground = registerColor('editorMarkerNavigation.background', {
  dark: '#2D2D30',
  light: Color.white,
  hc: '#0C141F'
}, nls.localize('editorMarkerNavigationBackground', 'Editor marker navigation widget background.'));
registerThemingParticipant(function (theme, collector) {
  var linkFg = theme.getColor(textLinkForeground);

  if (linkFg) {
    collector.addRule(".monaco-editor .marker-widget a { color: ".concat(linkFg, "; }"));
    collector.addRule(".monaco-editor .marker-widget a.code-link span:hover { color: ".concat(linkFg, "; }"));
  }
});